import React, { useState, useEffect, useRef } from "react";
import Swal from "sweetalert2";
import {
  Typography,
  Button,
  Box,
  useMediaQuery,
  useTheme,
  Autocomplete,
  TextField,
  Alert,
} from "@mui/material";
import miau from "../../img/miau.jpeg";
import tanque from "../../img/Flete.jpg";
import RouteIcon from "@mui/icons-material/Route";
import * as Yup from "yup";
import routeData from "./Util/Rutas.json";
import { carga } from "./Util/ConsumosFactorPeso";

const FleteCargadoCargado = [
  {
    FactorPiloto: 0.13684,
    FactorViaticos: 0.14737,
    FactorMantenimiento: 0.26,
    FactorAdministracion: 0.17066,
  },
];

const FleteVacioCargado = [
  {
    FactorPiloto: 0.07766,
    FactorViaticos: 0.06002,
    FactorMantenimiento: 0.065,
    FactorAdministracion: 0.04225,
  },
];

const FleteVCargadoVacio = [
  {
    FactorPiloto: 0.22388,
    FactorViaticos: 0.15858,
    FactorMantenimiento: 0.39,
    FactorAdministracion: 0.25034,
  },
];

export default function InfoFlete() {
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up("md"));
  const isMobileScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const isMobile = useMediaQuery("(max-width:600px)");
  const [selectedOrigin, setSelectedOrigin] = useState(null);
  const [selectedDestination, setSelectedDestination] = useState(null);
  const [rutaActual, setRutaActual] = useState(null);
  const [selectedReferencia, setSelectedReferencia] = useState(null);
  const [calculosTemporales2, setCalculosTemporales2] = useState(null);
  const [calculosvaciocargado1, setcalculosvaciocargado1] = useState(null);
  const [calculosvaciocargado2, setcalculosvaciocargado2] = useState(null);
  const [activeModalidad2, setActiveModalidad2] = useState(null);
  const [error, setError] = useState("");
  const [validationErrors, setValidationErrors] = useState({});
  const [pesoBruto, setPesoBruto] = useState("");
  const [isReturnLoad, setIsReturnLoad] = useState(false);
  const [precioCombustible, setPrecioCombustible] = useState("");
  const [activeModalidad, setActiveModalidad] = useState(null);
  const [calculosTemporales, setCalculosTemporales] = useState(null);
  const [showResults, setShowResults] = useState(false);
  const [showContent, setShowContent] = useState(true);
  const [isDisabled, setIsDisabled] = useState(false);
  const [mostrarRuta, setMostrarRuta] = useState(false);
  const [mostrarFlete, setMostrarFlete] = useState(false);




  const routeValidationSchema = Yup.object().shape({
    origin: Yup.string()
      .required("Debe seleccionar una ciudad de origen")
      .nullable(),
    destination: Yup.string()
      .required("Debe seleccionar una ciudad de destino")
      .nullable()
      .test("valid-route", "Ruta no válida", function (value) {
        const { origin } = this.parent;
        if (!origin || !value) return true;
        // Verificar la ruta en ambas direcciones
        return routeData.some(
          (route) =>
            (route.origen === origin && route.destino === value) ||
            (route.origen === value && route.destino === origin)
        );
      }),
  });

  useEffect(() => {
    if (
      isMobileScreen &&
      isReturnLoad &&
      showContent &&
      selectedReferencia &&
      pesoBruto &&
      precioCombustible &&
      !calculosvaciocargado2 &&
       activeModalidad === "Vacío-Cargado"
    ) {
      handleVacioCargadoSinSwal(FleteVacioCargado, "Vacío-Cargado");
    }
  }, [
    isMobileScreen,
    isReturnLoad,
    showContent,
    selectedReferencia,
    pesoBruto,
    precioCombustible,
  ]);

  const validateRoute = async (origin, destination) => {
    try {
      await routeValidationSchema.validate(
        { origin, destination },
        { abortEarly: false }
      );
      setValidationErrors({});
      return true;
    } catch (err) {
      const errors = {};
      err.inner.forEach((error) => {
        errors[error.path] = error.message;
      });
      setValidationErrors(errors);
      return false;
    }
  };

  const validationSchema = Yup.object().shape({
    precioCombustible: Yup.number()
      .typeError("Debe ser un número")
      .positive("El precio debe ser mayor que cero")
      .required("Este campo es obligatorio")
      .test(
        "max-decimal-places",
        "Solo se permiten hasta 2 decimales",
        (value) => {
          if (value === undefined || value === null) return true;
          const regex = /^\d+(\.\d{0,2})?$/;
          return regex.test(value.toString());
        }
      ),
  });

  const formatDecimal = (value) => {
    let cleaned = value.replace(/[^\d.]/g, "");
    const parts = cleaned.split(".");
    if (parts.length > 2) {
      cleaned = parts[0] + "." + parts.slice(1).join("");
    }
    if (parts.length === 2 && parts[1].length > 2) {
      cleaned = parts[0] + "." + parts[1].substring(0, 2);
    }

    return cleaned;
  };
  const validatePrecioCombustible = async (value) => {
    try {
      await validationSchema.validate(
        { precioCombustible: value },
        { abortEarly: false }
      );
      setValidationErrors({});
      return true;
    } catch (err) {
      const errors = {};
      err.inner.forEach((error) => {
        errors[error.path] = error.message;
      });
      setValidationErrors(errors);
      return false;
    }
  };

  const calcularFactoresModalidad = (modalidad, rutaParam = null) => {
    const ruta = rutaParam || rutaActual;

    if (!ruta) return null;

    const factores = modalidad[0];
    const kilometraje = ruta.kilometraje;

    const calculations = {
      factorPiloto: kilometraje * factores.FactorPiloto,
      factorViaticos: kilometraje * factores.FactorViaticos,
      factorMantenimiento: kilometraje * factores.FactorMantenimiento,
      factorAdministracion: kilometraje * factores.FactorAdministracion,
    };
    return calculations;
  };

  const calculateFuelConsumption = (
    rutaActualParam,
    pesoBrutoParam,
    isVacio
  ) => {
    const isVacioboolean = isVacio === true;

    if (!rutaActualParam || !pesoBrutoParam) return null;

    // Si es tramo vacío, usar factor fijo de 9.50

    // Si es tramo cargado, usar factor según peso
    const factorInfo = getFactor(pesoBrutoParam);
    if (factorInfo) {
      const kilometraje = rutaActualParam.kilometraje;
      const consumo = kilometraje / factorInfo["KM / Factor / Galones"];
      return { consumo, factorInfo };
    }
    return null;
  };

  const getAvailableReturnDestinations = (currentDestination) => {
    if (!currentDestination) return [];

    return [
      ...new Set([
        ...routeData
          .filter(
            (ruta) =>
              ruta.origen === currentDestination ||
              ruta.destino === currentDestination
          )
          .map((ruta) =>
            ruta.origen === currentDestination ? ruta.destino : ruta.origen
          ),
      ]),
    ].sort();
  };

  const uniqueOrigins = [
    ...new Set([
      ...routeData.map((ruta) => ruta.origen),
      ...routeData.map((ruta) => ruta.destino),
    ]),
  ].sort();

  const availableDestinations = selectedOrigin
    ? [
      ...new Set([
        ...routeData
          .filter(
            (ruta) =>
              ruta.origen === selectedOrigin ||
              ruta.destino === selectedOrigin
          )
          .map((ruta) =>
            ruta.origen === selectedOrigin ? ruta.destino : ruta.origen
          ),
      ]),
    ].sort()
    : [];

  const confirmarYLimpiar = (modalidad, nombre, mensaje) => {
    if (!rutaActual || !pesoBruto) {
      setError("Por favor completa todos los campos requeridos.");
      return;
    }

    if (!isMobileScreen) {
      setMostrarFlete(true);
      setMostrarRuta(true);
    }

    setIsDisabled(true);

    if (nombre === "Cargado-Cargado") {
      Swal.fire({
        title: mensaje,
        showCancelButton: true,
        confirmButtonText: "Sí",
        cancelButtonText: "No",
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: {
          cancelButton: "swal2-red-button",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          // Carga para otra ciudad
          setIsReturnLoad(true);
          calcularModalidadTemp(modalidad, nombre);
          setShowResults(true);
          if (!isMobileScreen) {
            setMostrarFlete(true);
            setMostrarRuta(true);  // y/o setMostrarRuta(true) si corresponde
          }
        } else {
          setShowContent(false);
          setIsReturnLoad(false);
          calcularModalidadTemp(modalidad, nombre);
          if (!isMobileScreen) {
            setMostrarFlete(true); 
            setMostrarRuta(true);  // y/o setMostrarRuta(true) si corresponde
          }
        }
      });
    } else if (nombre === "Vacío-Cargado") {
      Swal.fire({
        title: "Indique el destino de la carga",
        showCancelButton: true,
        confirmButtonText: "¿La carga es de retorno?",
        cancelButtonText: "¿La carga es para otra ciudad?",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          // La carga es de retorno nueva funcion a la cual vamos a pasar la modalidad y el nombre
          setIsReturnLoad(false);
          //calcularModalidadTemp(modalidad, nombre);
          calcularModalidadVacioCargado(modalidad, nombre);
          if (!isMobileScreen) {
            setMostrarFlete(true);  
            setMostrarRuta(true);
          }
        } else {
          // La carga es para otra ciudad
          setIsReturnLoad(true);
          setShowContent(true);
          // nueva modalidad para cargar la wea
          calcularModalidadVacioCargado(modalidad, nombre);
          setShowResults(true);
          if (!isMobileScreen) {
            setMostrarFlete(true);   // y/o setMostrarRuta(true) si corresponde
            setMostrarRuta(true);
          }
          setActiveModalidad("Vacío-Cargado");
        }
      });
    } else {
      calcularModalidadTemp(modalidad, nombre);
    }
  };
  // 1. Crea la función que hace la misma acción que el 'else' sin mostrar Swal:
  const handleVacioCargadoSinSwal = (modalidad, nombre) => {
    // Aquí forzamos la rama "La carga es para otra ciudad"
    setIsReturnLoad(true);
    setShowContent(true);
    calcularModalidadVacioCargado(modalidad, nombre);
    setShowResults(true);
    if (!isMobileScreen) {
      setMostrarFlete(true); 
      setMostrarRuta(true);
        // y/o setMostrarRuta(true) si corresponde
    }
  };

  const calcularModalidadVacioCargado = (modalidad, nombre) => {
    if (!modalidad || !rutaActual) {
      setError("Por favor selecciona una modalidad y una ruta válida.");
      return;
    }

    if (!pesoBruto) {
      setError("Por favor ingresa el peso bruto.");
      return;
    }

    if (!isReturnLoad && !selectedReferencia) {
      const factorInfo = getFactor(pesoBruto);
      const kilometraje = rutaActual.kilometraje;
      const consumo = kilometraje / factorInfo["KM / Factor / Galones"];

      const galonesdecombustiblevacio = kilometraje / 9.5;
      const preciogalonescombustible =
        galonesdecombustiblevacio * parseFloat(precioCombustible);

      const factoresVacio = FleteVacioCargado[0];
      const gastosTotalesVacio =
        factoresVacio.FactorPiloto * kilometraje +
        factoresVacio.FactorViaticos * kilometraje +
        factoresVacio.FactorMantenimiento * kilometraje +
        factoresVacio.FactorAdministracion * kilometraje +
        preciogalonescombustible;

      // Calculamos el tramo cargado
      const factorInfoCargado = getFactor(pesoBruto);
      const galonesdecombustiblecargado =
        kilometraje / factorInfoCargado["KM / Factor / Galones"];
      const preciogalonescombustiblecargado =
        galonesdecombustiblecargado * parseFloat(precioCombustible);

      const factores = FleteVCargadoVacio[0];
      const gastosTotalesCargado =
        factores.FactorPiloto * kilometraje +
        factores.FactorViaticos * kilometraje +
        factores.FactorMantenimiento * kilometraje +
        factores.FactorAdministracion * kilometraje +
        preciogalonescombustiblecargado;

      // Calcular utilidad correcta siguiendo el documento
      const utilidadliquida =
        (preciogalonescombustible +
          preciogalonescombustiblecargado +
          factores.FactorPiloto * kilometraje +
          factores.FactorViaticos * kilometraje +
          factores.FactorMantenimiento * kilometraje +
          factores.FactorAdministracion * kilometraje) *
        0.15;

      const valortarifa =
        preciogalonescombustible +
        preciogalonescombustiblecargado +
        factores.FactorPiloto * kilometraje +
        factores.FactorViaticos * kilometraje +
        factores.FactorMantenimiento * kilometraje +
        factores.FactorAdministracion * kilometraje +
        utilidadliquida;

      // Objeto de reporte
      const calculosTempNew = {
        id: Date.now(),
        origen: selectedOrigin,
        destino: selectedDestination,
        info: {
          kilometraje: rutaActual.kilometraje * 2,
          consumodieseltotal:
            galonesdecombustiblecargado + galonesdecombustiblevacio,
          gastocombustibletotal:
            preciogalonescombustible + preciogalonescombustiblecargado,
          rutaCompleta: rutaActual.ruta_completa || [],
          pagopilotopromedio: factores.FactorPiloto * kilometraje,
          pagoviaticospromedio: factores.FactorViaticos * kilometraje,
          pagomantenimientopromedio: factores.FactorMantenimiento * kilometraje,
          pagoadministracionpromedio:
            factores.FactorAdministracion * kilometraje,
          utilidadliquida: utilidadliquida,
          valortarifa: valortarifa,
        },
      };

      setcalculosvaciocargado1(calculosTempNew);
    }
    if (!isMobileScreen) {
      setMostrarFlete(true);   // y/o setMostrarRuta(true) si corresponde
      setMostrarRuta(true);
    }

    if (isReturnLoad && selectedReferencia) {
      // 1. Obtener ruta de retorno
      const rutaRetorno = routeData.find(
        (route) =>
          (route.origen === selectedDestination &&
            route.destino === selectedReferencia) ||
          (route.origen === selectedReferencia &&
            route.destino === selectedDestination)
      );

      if (!rutaRetorno) {
        console.error("No se encontró ruta válida para el retorno");
        return;
      }

      // 2. Calcular tramo VACÍO
      const factorVacio = 9.5;
      const consumoVacio = rutaActual.kilometraje / factorVacio;
      const gastoCombustibleVacio =
        consumoVacio * parseFloat(precioCombustible);

      const gastosVacio = {
        piloto: rutaActual.kilometraje * FleteVacioCargado[0].FactorPiloto,
        viaticos: rutaActual.kilometraje * FleteVacioCargado[0].FactorViaticos,
        mantenimiento:
          rutaActual.kilometraje * FleteVacioCargado[0].FactorMantenimiento,
        administracion:
          rutaActual.kilometraje * FleteVacioCargado[0].FactorAdministracion,
        combustible: gastoCombustibleVacio,
      };

      // 3. Calcular tramo CARGADO
      const factorInfoCargado = getFactor(pesoBruto);
      const consumoCargado =
        rutaRetorno.kilometraje / factorInfoCargado["KM / Factor / Galones"];
      const gastoCombustibleCargado =
        consumoCargado * parseFloat(precioCombustible);

      const gastosCargado = {
        piloto: rutaRetorno.kilometraje * FleteCargadoCargado[0].FactorPiloto,
        viaticos:
          rutaRetorno.kilometraje * FleteCargadoCargado[0].FactorViaticos,
        mantenimiento:
          rutaRetorno.kilometraje * FleteCargadoCargado[0].FactorMantenimiento,
        administracion:
          rutaRetorno.kilometraje * FleteCargadoCargado[0].FactorAdministracion,
        combustible: gastoCombustibleCargado,
      };

      // 4. Sumar ambos tramos
      const kilometrajeTotal = rutaActual.kilometraje + rutaRetorno.kilometraje;
      const gastosTotales = {
        piloto: gastosVacio.piloto + gastosCargado.piloto,
        viaticos: gastosVacio.viaticos + gastosCargado.viaticos,
        mantenimiento: gastosVacio.mantenimiento + gastosCargado.mantenimiento,
        administracion:
          gastosVacio.administracion + gastosCargado.administracion,
        combustible: gastosVacio.combustible + gastosCargado.combustible,
      };
      const totalGastos = Object.values(gastosTotales).reduce(
        (a, b) => a + b,
        0
      );
      const utilidad = totalGastos * 0.15;

      // 5. Construir la ruta detallada concatenando

      let rutaCompletaConDetalles = "";

      rutaCompletaConDetalles += rutaActual.ruta_completa
        ? rutaActual.ruta_completa
        : "No hay instrucciones para este tramo.\n";
      // 6. Crear estructura final
      const reporteFinal = {
        tramoVacio: {
          kilometraje: rutaActual.kilometraje,
          consumodieseltotal: consumoVacio.toFixed(2),
          gastocombustibletotal: gastosVacio.combustible.toFixed(2),
          pagopilotopromedio: gastosVacio.piloto.toFixed(2),
          pagoviaticospromedio: gastosVacio.viaticos.toFixed(2),
          pagomantenimientopromedio: gastosVacio.mantenimiento.toFixed(2),
          pagoadministracionpromedio: gastosVacio.administracion.toFixed(2),
        },
        tramoCargado: {
          kilometraje: rutaRetorno.kilometraje,
          consumodieseltotal: consumoCargado.toFixed(2),
          gastocombustibletotal: gastoCombustibleCargado.toFixed(2),
          pagopilotopromedio: gastosCargado.piloto.toFixed(2),
          pagoviaticospromedio: gastosCargado.viaticos.toFixed(2),
          pagomantenimientopromedio: gastosCargado.mantenimiento.toFixed(2),
          pagoadministracionpromedio: gastosCargado.administracion.toFixed(2),
        },
        total: {
          kilometraje: kilometrajeTotal,
          consumodieseltotal: (consumoVacio + consumoCargado).toFixed(2),
          gastocombustibletotal: gastosTotales.combustible.toFixed(2),

          // AQUÍ es donde asignamos el texto largo con detalles
          rutaCompleta: rutaCompletaConDetalles,

          pagopilotopromedio: gastosTotales.piloto.toFixed(2),
          pagoviaticospromedio: gastosTotales.viaticos.toFixed(2),
          pagomantenimientopromedio: gastosTotales.mantenimiento.toFixed(2),
          pagoadministracionpromedio: gastosTotales.administracion.toFixed(2),
          utilidadliquida: utilidad.toFixed(2),
          valortarifa: (totalGastos + utilidad).toFixed(2),
        },
      };
      // Guardar datos
      setCalculosTemporales(reporteFinal);
      setcalculosvaciocargado2(reporteFinal);
    }
  };

  const calcularModalidadTemp = (modalidad, nombre) => {
    if (!modalidad || !rutaActual) {
      setError("Por favor selecciona una modalidad y una ruta válida.");
      return;
    }

    if (!pesoBruto) {
      setError("Por favor ingresa el peso bruto.");
      return;
    }

    let calculos = calcularFactoresModalidad(modalidad);
    let consumoTotal, factorInfo;

    if (nombre === "Cargado-Vacío") {
      // Cálculo para tramo cargado
      const fuelCalculationCargado = calculateFuelConsumption(
        rutaActual,
        pesoBruto,
        false
      );
      // Cálculo para tramo vacío con peso mínimo
      const pesoVacio = "1";
      const fuelCalculationVacio = calculateFuelConsumption(
        rutaActual,
        pesoVacio,
        true
      );

      if (!fuelCalculationCargado || !fuelCalculationVacio) {
        setError("Error en el cálculo de combustible");
        return;
      }

      consumoTotal =
        fuelCalculationCargado.consumo + fuelCalculationVacio.consumo;
      factorInfo = fuelCalculationCargado.factorInfo;
    } else if (nombre === "Vacío-Cargado") {
      // Cálculo para tramo vacío y cargado
      const pesoVacio = "1";
      const fuelCalculationVacio = calculateFuelConsumption(
        rutaActual,
        pesoVacio,
        true
      );
      const fuelCalculationCargado = calculateFuelConsumption(
        rutaActual,
        pesoBruto,
        false
      );

      if (!fuelCalculationVacio || !fuelCalculationCargado) {
        setError("Error en el cálculo de combustible");
        return;
      }

      if (!isReturnLoad) {
        calculos = calcularFactoresModalidad(FleteVCargadoVacio);
      }

      consumoTotal =
        fuelCalculationVacio.consumo + fuelCalculationCargado.consumo;
      factorInfo = fuelCalculationCargado.factorInfo;
    } else {
      const fuelCalculation = calculateFuelConsumption(
        rutaActual,
        pesoBruto,
        false
      );
      if (!fuelCalculation) {
        setError("Error en el cálculo de combustible");
        return;
      }
      consumoTotal = fuelCalculation.consumo;
      factorInfo = fuelCalculation.factorInfo;
    }

    const costoTotal =
      calculos.factorPiloto +
      calculos.factorViaticos +
      calculos.factorMantenimiento +
      calculos.factorAdministracion +
      (consumoTotal && precioCombustible
        ? consumoTotal * parseFloat(precioCombustible)
        : 0);

    const total15Value = costoTotal * 0.15;
    const sumaTotalValue = costoTotal + total15Value;

    const calculosTemp = {
      id: Date.now(),
      origen: selectedOrigin,
      destino: selectedDestination,
      info: {
        kilometraje:
          nombre === "Cargado-Vacío" ||
            (nombre === "Vacío-Cargado" && isReturnLoad === true)
            ? rutaActual.kilometraje * 2
            : rutaActual.kilometraje,
        tipoEquipo: factorInfo["EQUIPOS ELECTRONICOS"],
        factor: factorInfo["KM / Factor / Galones"],
        consumoCombustible: consumoTotal.toFixed(2),
        costoCombustible: precioCombustible
          ? (consumoTotal * parseFloat(precioCombustible)).toFixed(2)
          : null,
        rutaCompleta: rutaActual.ruta_completa || [],
        modalidad: nombre,
        calculos: {
          factorPiloto: calculos.factorPiloto,
          factorViaticos: calculos.factorViaticos,
          factorMantenimiento: calculos.factorMantenimiento,
          factorAdministracion: calculos.factorAdministracion,
          total: costoTotal.toFixed(2),
          total15: total15Value.toFixed(2),
          sumatotal: sumaTotalValue.toFixed(2),
        },
      },
    };

    if (isReturnLoad && selectedReferencia) {
      calcularModalidadTemp2(modalidad, nombre);
    }

    setActiveModalidad(nombre);
    setCalculosTemporales(calculosTemp);
    if (!isMobileScreen) {
      setMostrarFlete(true);   // y/o setMostrarRuta(true) si corresponde
      setMostrarRuta(true);
    }
  };

  const calculateTotals = ({
    calculosTemporales,
    calculosTemporales2,
  } = {}) => {
    try {
      if (!calculosTemporales?.info) {
        return {
          totalKilometraje: 0,
          totalCombustible: 0,
          totalCostoCombustible: 0,
          totalCosto: 0,
          sumatotal: 0,
          totalPiloto: 0,
          totalMantenimiento: 0,
          totalAdministracion: 0,
          totalViaticos: 0,
        };
      }

      const safeSum = (a, b) => {
        const numA = parseFloat(a) || 0;
        const numB = parseFloat(b) || 0;
        return Number((numA + numB).toFixed(2));
      };

      // Si es modalidad Cargado-Vacío, usar solo valores del primer tramo
      if (calculosTemporales.info.modalidad === "Cargado-Vacío") {
        const info = calculosTemporales.info;
        return {
          totalKilometraje: parseFloat(info.kilometraje),
          totalCombustible: parseFloat(info.consumoCombustible),
          totalCostoCombustible: parseFloat(info.costoCombustible),
          totalPiloto: info.calculos.factorPiloto,
          totalMantenimiento: info.calculos.factorMantenimiento,
          totalAdministracion: info.calculos.factorAdministracion,
          totalViaticos: info.calculos.factorViaticos,
          totalCosto: parseFloat(info.calculos.total),
          sumatotal: parseFloat(info.calculos.total15),
          totalsuma: parseFloat(info.calculos.sumatotal),
        };
      }

      // Para otras modalidades, sumar ambos tramos
      const {
        kilometraje: km1 = 0,
        consumoCombustible: dicel1 = 0,
        costoCombustible: costo1 = 0,
        calculos: {
          total: total1 = 0,
          total15: totalsi1 = 0,
          factorPiloto: piloto1 = 0,
          factorMantenimiento: mantenimiento1 = 0,
          factorAdministracion: administracion1 = 0,
          factorViaticos: viaticos1 = 0,
          sumatotal: sumatotal1 = 0,
        } = {},
      } = calculosTemporales.info;

      const {
        kilometraje: km2 = 0,
        consumoCombustible: dicel2 = 0,
        costoCombustible: costo2 = 0,
        calculos: {
          total: total2 = 0,
          total15: totalsi2 = 0,
          factorPiloto: piloto2 = 0,
          factorMantenimiento: mantenimiento2 = 0,
          factorAdministracion: administracion2 = 0,
          factorViaticos: viaticos2 = 0,
          sumatotal: sumatotal2 = 0,
        } = {},
      } = calculosTemporales2?.info || {};

      return {
        totalKilometraje: safeSum(km1, km2),
        totalCombustible: safeSum(dicel1, dicel2),
        totalCostoCombustible: safeSum(costo1, costo2),
        totalCosto: safeSum(total1, total2),
        sumatotal: safeSum(totalsi1, totalsi2),
        totalPiloto: safeSum(piloto1, piloto2),
        totalMantenimiento: safeSum(mantenimiento1, mantenimiento2),
        totalAdministracion: safeSum(administracion1, administracion2),
        totalViaticos: safeSum(viaticos1, viaticos2),
        totalsuma: safeSum(sumatotal1, sumatotal2),
      };
    } catch (error) {
      console.error("Error al calcular totales:", error);
      return {
        totalKilometraje: 0,
        totalCombustible: 0,
        totalCostoCombustible: 0,
        totalCosto: 0,
        sumatotal: 0,
        totalPiloto: 0,
        totalMantenimiento: 0,
        totalAdministracion: 0,
        totalViaticos: 0,
      };
    }
  };

  const calcularModalidadTemp2 = (modalidad, nombre) => {
    // Siempre usar FleteVacioCargado para el segundo tramo
    const modalidadParaCalculo = FleteVacioCargado;

    if (!modalidadParaCalculo || !selectedReferencia) {
      setError(
        "Por favor selecciona una modalidad y una ciudad de referencia."
      );
      return;
    }

    if (!pesoBruto) {
      setError("Por favor ingresa el peso bruto.");
      return;
    }

    const rutaReferencia = routeData.find(
      (route) =>
        (route.origen === selectedDestination &&
          route.destino === selectedReferencia) ||
        (route.origen === selectedReferencia &&
          route.destino === selectedDestination)
    );

    if (!rutaReferencia) {
      setError("No se encontró una ruta válida para la ciudad de referencia.");
      return;
    }

    // Usar factores específicos para tramo vacío
    const calculos = {
      factorPiloto: rutaReferencia.kilometraje * 0.07766,
      factorViaticos: rutaReferencia.kilometraje * 0.06002,
      factorMantenimiento: rutaReferencia.kilometraje * 0.065,
      factorAdministracion: rutaReferencia.kilometraje * 0.04225,
    };

    // Calcular consumo con factor fijo para camión vacío
    const factorVacio = 9.5;
    const consumo = rutaReferencia.kilometraje / factorVacio;

    const costoCombustible = consumo * parseFloat(precioCombustible);

    const costoTotal =
      calculos.factorPiloto +
      calculos.factorViaticos +
      calculos.factorMantenimiento +
      calculos.factorAdministracion +
      costoCombustible;

    const total15Value = costoTotal * 0.15;
    const sumaTotalValue = costoTotal + total15Value;

    const newCalculosTemp2 = {
      id: Date.now(),
      origen: selectedDestination,
      destino: selectedReferencia,
      info: {
        kilometraje: rutaReferencia.kilometraje,
        tipoEquipo: "Cabezal con Furgón Vacío 1 a 2,999.99 kg",
        factor: factorVacio,
        consumoCombustible: consumo.toFixed(2),
        costoCombustible: costoCombustible.toFixed(2),
        rutaCompleta: rutaReferencia.ruta_completa,
        modalidad: nombre,
        calculos: {
          ...calculos,
          total: costoTotal.toFixed(2),
          total15: total15Value.toFixed(2),
          sumatotal: sumaTotalValue.toFixed(2),
        },
      },
    };

    // Calcular totales combinados
    const totales = {
      totalKilometraje:
        calculosTemporales.info.kilometraje + rutaReferencia.kilometraje,
      totalCombustible: (
        parseFloat(calculosTemporales.info.consumoCombustible) + consumo
      ).toFixed(2),
      totalCostoCombustible: (
        parseFloat(calculosTemporales.info.costoCombustible) + costoCombustible
      ).toFixed(2),
      totalPiloto: (
        calculosTemporales.info.calculos.factorPiloto + calculos.factorPiloto
      ).toFixed(2),
      totalMantenimiento: (
        calculosTemporales.info.calculos.factorMantenimiento +
        calculos.factorMantenimiento
      ).toFixed(2),
      totalAdministracion: (
        calculosTemporales.info.calculos.factorAdministracion +
        calculos.factorAdministracion
      ).toFixed(2),
      totalViaticos: (
        calculosTemporales.info.calculos.factorViaticos +
        calculos.factorViaticos
      ).toFixed(2),
      totalCosto: (
        parseFloat(calculosTemporales.info.calculos.total) + costoTotal
      ).toFixed(2),
      sumatotal: (
        parseFloat(calculosTemporales.info.calculos.total15) + total15Value
      ).toFixed(2),
      totalsuma: (
        parseFloat(calculosTemporales.info.calculos.sumatotal) + sumaTotalValue
      ).toFixed(2),
    };

    setCalculosTemporales2({
      ...newCalculosTemp2,
      info: {
        ...newCalculosTemp2.info,
        totales,
      },
    });

    setActiveModalidad2(null);
  };
  const formatearRuta = (rutaCompleta, invertir = false) => {
    if (!rutaCompleta || typeof rutaCompleta !== "string") {
      return [];
    }
    try {
      const lineas = rutaCompleta.split("\n").filter((l) => l.trim());
      const indicePasos = lineas.findIndex((l) => l.includes("- "));

      if (indicePasos === -1) {
        console.warn("No se encontraron pasos en la ruta");
        return [];
      }

      // Pasos que empiezan con "- "
      let pasos = lineas.slice(indicePasos).filter((p) => p.startsWith("- "));
      // Quitar el "- "
      pasos = pasos.map((p) => p.replace("- ", ""));

      // Si invert es true, los invertimos
      if (invertir) {
        pasos.reverse();
      }

      return pasos;
    } catch (error) {
      console.error("Error al formatear la ruta:", error);
      return [];
    }
  };

  const handleDestinationChange = async (event, newValue) => {
    await validateRoute(selectedOrigin, newValue);
    setSelectedDestination(newValue);
    if (newValue && selectedOrigin) {
      const foundRoute = routeData.find(
        (route) =>
          (route.origen === selectedOrigin && route.destino === newValue) ||
          (route.origen === newValue && route.destino === selectedOrigin)
      );
      setRutaActual(foundRoute || null);
    } else {
      setRutaActual(null);
    }
  };

  const handleOriginChange = async (event, newValue) => {
    await validateRoute(newValue, null);
    setSelectedOrigin(newValue);
    setSelectedDestination(null);
    setRutaActual(null);
  };

  const getFactor = (peso) => {
    const pesoNum = parseFloat(removeCommas(peso));
    let factorEncontrado;

    if (isNaN(pesoNum) || pesoNum === 0) {
      factorEncontrado = carga.find(
        (item) => item["EQUIPOS ELECTRONICOS"] === "Cabezal Sin Furgón de 0 kg"
      );
    } else if (pesoNum > 0 && pesoNum <= 2999.99) {
      factorEncontrado = carga.find(
        (item) =>
          item["EQUIPOS ELECTRONICOS"] ===
          "Cabezal con Furgón Vacío 1 a 2,999.99 kg"
      );
    } else if (pesoNum >= 3000 && pesoNum <= 8000) {
      factorEncontrado = carga.find(
        (item) =>
          item["EQUIPOS ELECTRONICOS"] ===
          "Carga liviana de 3,000 a 8,000.00 Kg"
      );
    } else if (pesoNum >= 8001 && pesoNum <= 12999.99) {
      factorEncontrado = carga.find(
        (item) =>
          item["EQUIPOS ELECTRONICOS"] ===
          "Carga liviana de 8,001 a 12,999.99 Kg"
      );
    } else if (pesoNum >= 13001 && pesoNum <= 17999.99) {
      factorEncontrado = carga.find(
        (item) =>
          item["EQUIPOS ELECTRONICOS"] ===
          "Carga liviana de 13,001 a 17,999.99 Kg"
      );
    } else if (pesoNum >= 18000 && pesoNum <= 21000) {
      factorEncontrado = carga.find(
        (item) =>
          item["EQUIPOS ELECTRONICOS"] === "Cargado de 18,000 a 21,000.00 Kg"
      );
    } else if (pesoNum >= 21001 && pesoNum <= 23999.99) {
      factorEncontrado = carga.find(
        (item) =>
          item["EQUIPOS ELECTRONICOS"] === "Peso de 21,001 a 23,999.99 Kg"
      );
    } else if (pesoNum >= 24000 && pesoNum <= 26999.99) {
      factorEncontrado = carga.find(
        (item) =>
          item["EQUIPOS ELECTRONICOS"] === "Pesado de 24,000 a 26,999.99 Kg"
      );
    } else if (pesoNum >= 27000) {
      factorEncontrado = carga.find(
        (item) =>
          item["EQUIPOS ELECTRONICOS"] === "Sobre Peso de 27,000 a 30,000 kg"
      );
    }

    return factorEncontrado;
  };

 const handlePesoBrutoChange = (event) => {
    let value = event.target.value;
    
    // Permitir borrar números
    if (value.length < (pesoBruto || "").length) {
      setPesoBruto(value);
      setError("");
      return;
    }
    
    // Permitir solo números, punto decimal y comas
    if (!/^[\d,.]*(\.?\d{0,2})?$/.test(value)) {
      return;
    }
    
    // Manejar caso especial: si termina con punto, permitirlo temporalmente
    if (value.endsWith('.') && !value.slice(0, -1).includes('.')) {
      setPesoBruto(value);
      setError("");
      return;
    }
    
    // Remover comas para validar el número
    const numeroSinFormato = value.replace(/,/g, "");
    
    // Si no es un número válido, no continuar (pero permitir string vacío)
    if (numeroSinFormato && isNaN(numeroSinFormato)) {
      return;
    }
    
    // Si no hay punto en el valor original, solo formatear la parte entera
    if (!value.includes('.')) {
      // Si el número original tenía exactamente 5 dígitos (ej: 30000 que se muestra como 30,000)
      // y ahora tiene 6 dígitos, convertir el último en decimal
      const valorAnteriorSinFormato = (pesoBruto || "").replace(/,/g, "").replace(/\./g, "");
      
      if (valorAnteriorSinFormato.length === 5 && numeroSinFormato.length === 6) {
        const entero = numeroSinFormato.slice(0, 5);
        const decimal = numeroSinFormato.slice(5);
        
        // Verificar límite con el número correctamente formateado
        const numeroConDecimal = parseFloat(`${entero}.${decimal}`);
        if (numeroConDecimal > 35999.99) {
          setPesoBruto("35,999.99");
          setError("El valor no puede exceder 35,999.99");
          return;
        }
        
        const formattedEntero = entero.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        setPesoBruto(`${formattedEntero}.${decimal}`);
        setError("");
        return;
      }
      
      // Para otros casos, verificar límite del número entero
      const numero = parseFloat(numeroSinFormato);
      if (numero > 35999.99) {
        setPesoBruto("35,999.99");
        setError("El valor no puede exceder 35,999.99");
        return;
      }
      
      // Solo aplicar formato de miles
      const formattedEntero = numeroSinFormato.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      setPesoBruto(formattedEntero);
      setError("");
      return;
    }
    
    // Verificar que el valor es un número válido y no excede el límite
    const numero = parseFloat(numeroSinFormato);
    if (numero > 35999.99) {
      setPesoBruto("35,999.99");
      setError("El valor no puede exceder 35,999.99");
      return;
    }
    
    // Formatear el número
    let [entero, decimal = ""] = numeroSinFormato.split(".");
    
    // Aplicar formato de miles a la parte entera
    let formattedEntero = entero.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    
    // Reconstruir el valor formateado
    let finalValue;
    if (decimal !== "") {
      // Si hay decimales, incluirlos (limitados a 2 dígitos)
      finalValue = `${formattedEntero}.${decimal.slice(0, 2)}`;
    } else if (value.includes('.')) {
      // Si el valor original incluía un punto pero no hay decimales, mantener el punto
      finalValue = `${formattedEntero}.`;
    } else {
      // Solo la parte entera
      finalValue = formattedEntero;
    }
    
    setPesoBruto(finalValue);
    setError("");
  };

  const removeCommas = (value) => {
    return value.replace(/,/g, "");
  };

  const handlePrecioCombustibleChange = (event) => {
    let value = event.target.value;
    const formattedValue = formatDecimal(value);
    if (formattedValue !== value) {
      setPrecioCombustible(formattedValue);
    } else {
      setPrecioCombustible(value);
    }
    validatePrecioCombustible(formattedValue);
  };

  const invert = rutaActual
    ? selectedOrigin === rutaActual.destino &&
    selectedDestination === rutaActual.origen
    : false;

useEffect(() => {
  if (
    isMobileScreen &&
    isReturnLoad &&
    showContent &&
    selectedReferencia &&
    pesoBruto &&
    precioCombustible &&
    !calculosvaciocargado2 &&
    activeModalidad === "Vacío-Cargado"   // ✅ sólo cuando toca
  ) {
    handleVacioCargadoSinSwal(FleteVacioCargado, "Vacío-Cargado");
  }
}, [
  isMobileScreen,
  isReturnLoad,
  showContent,
  selectedReferencia,
  pesoBruto,
  precioCombustible,
  activeModalidad,
  calculosvaciocargado2,
]);


  return (
    <div>
      <div className="flex flex-col items-center justify-center w-full bg-cover bg-center bg-no-repeat bg-[#662583]">
        <br />
        <div className="flex items-center">
          <img
            src={tanque}
            alt="Tanque de Gasolina"
            className="w-16 h-16 mr-4 rounded-2xl"
          />
          <Typography
            variant={isLargeScreen ? "h3" : "h6"}
            className="text-white font-bold text-center"
            style={{ fontSize: isMobile ? "17px" : "h3" }}
          >
            Obtener Informacion de un Flete
          </Typography>
        </div>
        <br />
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2">
        {(!isMobileScreen || (!mostrarRuta && !mostrarFlete)) && (
          <div className="bg-white lg:mt-4">
            <Typography
              variant={isLargeScreen ? "h5" : "h6"}
              className="text-center text-black -800 font-bold"
            >
              INGRESE INFORMACION Y MODALIDAD DEL FLETE
            </Typography>

            <div className="space-y-6 mt-4">
              <Box
                className="flex flex-col md:flex-row gap-2"
                display="flex"
                mb={2}
              >
                <div className="w-full mb-2 md:w-1/2">
                  <Autocomplete
                    options={uniqueOrigins}
                    value={selectedOrigin}
                    onChange={handleOriginChange}
                    disabled={isDisabled} // Deshabilitar si isDisabled es true
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        type="text"
                        label="Ciudad Origen"
                        error={!!validationErrors.origin}
                        helperText={validationErrors.origin}
                        required
                      />
                    )}
                  />
                </div>
                <div className="w-full md:w-1/2">
                  <Autocomplete
                    options={availableDestinations}
                    value={selectedDestination}
                    onChange={handleDestinationChange}
                    disabled={!selectedOrigin || isDisabled} // Deshabilitar si no hay origen seleccionado o si isDisabled es true
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Ciudad Primer Destino"
                        error={!!validationErrors.destination}
                        helperText={validationErrors.destination}
                        required
                      />
                    )}
                  />
                </div>
              </Box>
              <div className="space-y-4">
                <TextField
                  label="Peso Bruto de la Carga (kg)"
                  variant="outlined"
                  fullWidth
                  value={pesoBruto}
                  onChange={handlePesoBrutoChange}
                  className="focus:ring focus:ring-blue-500 transition duration-200 ease-in-out"
                  error={!!error}
                  helperText={error}
                  inputProps={{
                    inputMode: "decimal",
                  }}
                />
                {error && (
                  <Alert severity="error" className="mt-4">
                    {error}
                  </Alert>
                )}
                <TextField
                  label="Precio Combustible en Galones $"
                  variant="outlined"
                  fullWidth
                  type="number"
                  value={precioCombustible}
                  onChange={handlePrecioCombustibleChange}
                  onKeyDown={(e) => {
                    if (e.key === "." && precioCombustible.includes(".")) {
                      e.preventDefault();
                    }
                  }}
                  inputProps={{
                    step: "0.01",
                  }}
                  className="focus:ring focus:ring-blue-500 transition duration-200 ease-in-out"
                  error={!!validationErrors.precioCombustible}
                  helperText={validationErrors.precioCombustible}
                />
                {isReturnLoad && showContent && (
                  <Autocomplete
                    options={getAvailableReturnDestinations(
                      selectedDestination
                    )}
                    value={selectedReferencia}
                    onChange={(event, newValue) =>
                      setSelectedReferencia(newValue)
                    }
                    disabled={!selectedDestination}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Ciudad a Cargar para Retorno"
                        error={!!validationErrors.referencia}
                        helperText={validationErrors.referencia}
                        variant="outlined"
                      />
                    )}
                    sx={{ flex: 1 }}
                  />
                )}
              </div>
              <div className="space-y-4">
                {activeModalidad === null && !calculosvaciocargado1 && (
                  <Typography variant="h6" className="text-center">
                    INDIQUE MODALIDAD DEL FLETE
                  </Typography>
                )}
                {activeModalidad === null && !calculosvaciocargado1 && (
                  <div className="flex justify-center w-full">
                    <div className="flex flex-col md:flex-row md:space-x-4 space-y-4 md:space-y-0">
                      <Button
                        variant={
                          activeModalidad === "Cargado-Cargado"
                            ? "contained"
                            : "filled"
                        }
                        sx={{ backgroundColor: "#096eff", color: "#fff" }}
                        onClick={() =>
                          confirmarYLimpiar(
                            FleteCargadoCargado,
                            "Cargado-Cargado",
                            "¿Para cargar retorno se traslada a otra ciudad?"
                          )
                        }
                        disabled={
                          !rutaActual ||
                          !selectedOrigin ||
                          !selectedDestination ||
                          !pesoBruto ||
                          !precioCombustible ||
                          validationErrors.precioCombustible
                        }
                      >
                        Cargado-Cargado
                      </Button>
                      <Button
                        variant={
                          activeModalidad === "Cargado-Vacío"
                            ? "contained"
                            : "filled"
                        }
                        sx={{ backgroundColor: "#158854", color: "#fff" }}
                        onClick={() =>
                          confirmarYLimpiar(
                            FleteVCargadoVacio,
                            "Cargado-Vacío",
                            ""
                          )
                        }
                        disabled={
                          !rutaActual ||
                          !selectedOrigin ||
                          !selectedDestination ||
                          !pesoBruto ||
                          !precioCombustible ||
                          validationErrors.precioCombustible
                        }
                      >
                        Cargado-Vacío
                      </Button>
                      <Button
                        variant={
                          activeModalidad === "Vacío-Cargado"
                            ? "contained"
                            : "filled"
                        }
                        sx={{ backgroundColor: "#0ccaf3", color: "#000" }}
                        onClick={() =>
                          confirmarYLimpiar(
                            FleteVacioCargado,
                            "Vacío-Cargado",
                            ""
                          )
                        }
                        disabled={
                          !rutaActual ||
                          !selectedOrigin ||
                          !selectedDestination ||
                          !pesoBruto ||
                          !precioCombustible ||
                          validationErrors.precioCombustible
                        }
                      >
                        Vacío-Cargado
                      </Button>
                    </div>
                  </div>
                )}
                {(calculosTemporales && isReturnLoad && showContent) ||
                  (!calculosvaciocargado2 &&
                    isReturnLoad &&
                    showContent &&
                    !isMobileScreen && (
                      <Button
                        variant="contained"
                        color="primary"
                        sx={{ backgroundColor: "#096eff", color: "#fff" }}
                        onClick={() =>
                          handleVacioCargadoSinSwal(
                            FleteVacioCargado,
                            "Vacío-Cargado"
                          )
                        }
                        disabled={
                          !selectedReferencia ||
                          !pesoBruto ||
                          !precioCombustible
                        }
                        className="w-full"
                      >
                        Obtener Información
                      </Button>
                    ))}
                {calculosTemporales && isReturnLoad && showContent && (
                  <div className="p-4" style={{ marginBottom: "-35px" }}>
                    {!calculosvaciocargado2 && (
                      <Button
                        variant="contained"
                        color="primary"
                        sx={{ backgroundColor: "#096eff", color: "#fff" }}
                        onClick={() => {
                          if (activeModalidad === "Cargado-Cargado") {
                            calcularModalidadTemp2(
                              FleteCargadoCargado,
                              "Cargado-Cargado"
                            );
                          } else if (activeModalidad === "Vacío-Cargado") {
                            calcularModalidadTemp2(
                              FleteVacioCargado,
                              "Vacío-Cargado"
                            );
                          } else if (activeModalidad === "Cargado-Vacío") {
                            calcularModalidadTemp2(
                              FleteVCargadoVacio,
                              "Cargado-Vacío"
                            );
                          }
                          if (isMobileScreen) {
                            setMostrarFlete(!mostrarFlete);
                          } else {
                            setShowResults(true);
                          }
                        }}
                        disabled={
                          !selectedReferencia ||
                          !pesoBruto ||
                          !precioCombustible
                        }
                        className="w-full"
                      >
                        Obtener Información
                      </Button>
                    )}
                  </div>
                )}
                {calculosTemporales &&
                  isReturnLoad &&
                  showContent &&
                  isMobileScreen && (
                    <div className="p-4">
                      {!calculosvaciocargado2 && (
                        <Button
                          variant="contained"
                          color="primary"
                          sx={{ backgroundColor: "#096eff", color: "#fff" }}
                          onClick={() => {
                            setMostrarRuta(!mostrarRuta);
                          }}
                          disabled={
                            !selectedReferencia ||
                            !pesoBruto ||
                            !precioCombustible
                          }
                          className="w-full"
                        >
                          {showResults ? "Ver Ruta" : "Atras"}
                        </Button>
                      )}
                    </div>
                  )}
              </div>
              {!(calculosTemporales && isReturnLoad && showContent) && (
                <div className="space-y-4 p-4">
                  {calculosTemporales && isMobileScreen && (
                    <Button
                      variant="contained"
                      style={{ backgroundColor: "#0c6efe", color: "#fff" }}
                      onClick={() => {
                        setMostrarFlete(!mostrarFlete);
                      }}
                      className=" w-full"
                    >
                      {showResults ? "Atras" : "Obtener Información"}
                    </Button>
                  )}
                  {calculosTemporales && isMobileScreen && (
                    <Button
                      variant="contained"
                      style={{ backgroundColor: "#0c6efe", color: "#fff" }}
                      onClick={() => {
                        setMostrarRuta(!mostrarRuta);
                      }}
                      className="w-full p-4"
                    >
                      {showResults ? "Atras" : "Ver Ruta"}
                    </Button>
                  )}
                </div>
              )}
            </div>
          </div>
        )}

        <div>
          {mostrarFlete && calculosvaciocargado1 && isReturnLoad === false && (
            <div>
              <div>
                <Typography
                  variant={isLargeScreen ? "h5" : "h6"}
                  className="text-center text-black-800 font-bold"
                >
                  Información de Tarifa y Flete
                </Typography>
              </div>
              <div
                className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 gap-2 mb-2"
                variant={isLargeScreen ? "h5" : "h6"}
              >
                <div className="p-4 rounded-lg">
                  <Typography
                    variant="subtitle1"
                    className="text-black-600 font-medium"
                  >
                    Distancia en Kilómetros
                  </Typography>
                  <Typography variant="h5" className="text-black-700 font-bold">
                    {calculosvaciocargado1.info.kilometraje.toFixed(2)} km
                  </Typography>
                </div>
                <div className="p-4 rounded-lg">
                  <Typography variant="subtitle1" className="text-black-600">
                    Consumo de Diesel
                  </Typography>
                  <Typography variant="h5" className="font-bold text-black-700">
                    {calculosvaciocargado1.info.consumodieseltotal.toFixed(2)}{" "}
                    galones
                  </Typography>
                </div>
                <div className="p-4 rounded-lg">
                  <Typography variant="subtitle1" className="text-black-600">
                    Gasto de Combustible
                  </Typography>
                  <Typography variant="h5" className="font-bold text-black-700">
                    $
                    {calculosvaciocargado1.info.gastocombustibletotal.toFixed(
                      2
                    )}
                  </Typography>
                </div>
                <div className="p-4 rounded-lg">
                  <Typography variant="subtitle1" className="text-black-600">
                    Pago Piloto Promedio
                  </Typography>
                  <Typography variant="h5" className="font-bold text-black-700">
                    ${calculosvaciocargado1.info.pagopilotopromedio.toFixed(2)}
                  </Typography>
                </div>
                <div className="p-4 rounded-lg">
                  <Typography variant="subtitle1" className="text-black-600">
                    Gastos de Viáticos Promedio
                  </Typography>
                  <Typography variant="h5" className="font-bold text-black-700">
                    $
                    {calculosvaciocargado1.info.pagoviaticospromedio.toFixed(2)}
                  </Typography>
                </div>
                <div className="p-4 rounded-lg">
                  <Typography variant="subtitle1" className="text-black-600">
                    Fondo de Ahorro del Flete para Provision Mtto
                  </Typography>
                  <Typography variant="h5" className="font-bold text-black-700">
                    $
                    {calculosvaciocargado1.info.pagomantenimientopromedio.toFixed(
                      2
                    )}
                  </Typography>
                </div>
                <div className="p-4 rounded-lg">
                  <Typography variant="subtitle1" className="text-black-600">
                    Aporte del Flete para Administracion
                  </Typography>
                  <Typography variant="h5" className="font-bold text-black-700">
                    $
                    {calculosvaciocargado1.info.pagoadministracionpromedio.toFixed(
                      2
                    )}
                  </Typography>
                </div>
                <div className="p-4 rounded-lg">
                  <Typography variant="subtitle1" className="text-black-600">
                    Utilidad Líquida
                  </Typography>
                  <Typography variant="h5" className="font-bold text-black-700">
                    ${calculosvaciocargado1.info.utilidadliquida.toFixed(2)}
                  </Typography>
                </div>
                <div className="p-4 rounded-lg">
                  <Typography variant="subtitle1" className="text-black-600">
                    Valor de Tarifa
                  </Typography>
                  <Typography variant="h5" className="font-bold text-black-700">
                    ${calculosvaciocargado1.info.valortarifa.toFixed(2)}
                  </Typography>
                </div>
              </div>
            </div>
          )}
          <div className="p-4">
            {!mostrarRuta &&
              calculosvaciocargado1 &&
              isMobileScreen &&
              isReturnLoad === false && (
                <Button
                  variant="contained"
                  style={{
                    backgroundColor: "#0c6efe",
                    color: "#fff",
                    marginBottom: "-25px",
                  }}
                  onClick={() => {
                    setMostrarFlete(!mostrarFlete);
                  }}
                  className="w-full"
                >
                  {mostrarFlete ? "Atras" : "Obtener Información"}
                </Button>
              )}
          </div>

          {mostrarRuta === true &&
            calculosvaciocargado1 &&
            isReturnLoad === false && (
              <div>
                <Typography
                  variant="subtitle1"
                  className="font-semibold text-black mb-3 text-center"
                  style={{
                    fontSize: isMobile ? "15.5px" : "19px",
                    whiteSpace: "nowrap",
                    marginTop: isMobile ? "-35px" : "30px",
                  }}
                >
                  Mejor Ruta a Seguir en ambos Sentidos
                </Typography>

                <Typography
                  className="m-2 text-center"
                  style={{
                    fontSize: "15.5px",

                    marginLeft: "10px",
                    marginBottom: "10px",
                  }}
                >
                  <strong>
                    DE {selectedOrigin} A {selectedDestination}
                  </strong>
                </Typography>
                <div className="space-y-2 bg-white rounded-lg">
                  {calculosvaciocargado1.info.rutaCompleta ? (
                    formatearRuta(
                      calculosvaciocargado1.info.rutaCompleta,
                      invert
                    ).map((paso, index) => (
                      <div key={index} className="flex items-start space-x-3 ">
                        <div className="min-w-[24px] h-6 bg-black-100 rounded-full flex items-center justify-center">
                          <Typography
                            variant="body2"
                            className="text-black-600 "
                          >
                            -
                          </Typography>
                        </div>
                        <Typography
                          variant="body2"
                          className="text-black -600,"
                        >
                          {paso}
                        </Typography>
                      </div>
                    ))
                  ) : (
                    <Typography variant="body2" className="text-black -500">
                      No hay instrucciones disponibles
                    </Typography>
                  )}
                </div>
                <Typography
                  className="text-center"
                  style={{
                    fontSize: "15.5px",

                    marginLeft: "10px",
                  }}
                >
                  <strong>
                    DE {selectedDestination} A {selectedOrigin}
                  </strong>
                </Typography>
                {calculosTemporales && isMobileScreen && (
                  <div className="p-4">
                    <Button
                      variant="contained"
                      style={{
                        backgroundColor: "#0c6efe",
                        color: "#fff",
                      }}
                      onClick={() => {
                        setMostrarRuta(!mostrarRuta);
                      }}
                      className="w-full"
                    >
                      {mostrarRuta ? "Atras" : "Ver Ruta"}
                    </Button>
                  </div>
                )}
              </div>
            )}

          <div className="p-4">
            {!mostrarFlete &&
              calculosvaciocargado1 &&
              isMobileScreen &&
              isReturnLoad === false && (
                <Button
                  variant="contained"
                  style={{
                    backgroundColor: "#0c6efe",
                    color: "#fff",
                  }}
                  onClick={() => {
                    setMostrarRuta(!mostrarRuta);
                  }}
                  className="w-full"
                >
                  {mostrarRuta ? "Atras" : "Ver Ruta"}
                </Button>
              )}
          </div>

          {mostrarFlete && calculosvaciocargado2 && (
            <div>
              <div style={{ marginTop: "-50px" }}>
                <Typography
                  variant={isLargeScreen ? "h5" : "h6"}
                  className="text-center text-black -800 font-bold"
                >
                  Información de Tarifa y Flete
                </Typography>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 gap-2 mb-2">
                <div className="p-4 rounded-lg">
                  <Typography
                    variant="subtitle2"
                    className="text-black-600 font-medium"
                  >
                    Distancia en Kilómetros
                  </Typography>
                  <Typography variant="h5" className="text-black-700 font-bold">
                    {parseFloat(
                      calculosvaciocargado2.total.kilometraje
                    ).toFixed(2)}{" "}
                    km
                  </Typography>
                </div>

                <div className="p-4 rounded-lg">
                  <Typography variant="subtitle2" className="text-black-600">
                    Consumo de Diesel
                  </Typography>
                  <Typography variant="h5" className="font-bold text-black-700">
                    {parseFloat(
                      calculosvaciocargado2.total.consumodieseltotal
                    ).toFixed(2)}{" "}
                    galones
                  </Typography>
                </div>

                <div className="p-4 rounded-lg">
                  <Typography variant="subtitle2" className="text-black-600">
                    Gasto de Combustible
                  </Typography>
                  <Typography variant="h5" className="font-bold text-black-700">
                    $
                    {parseFloat(
                      calculosvaciocargado2.total.gastocombustibletotal
                    ).toFixed(2)}
                  </Typography>
                </div>

                <div className="p-4 rounded-lg">
                  <Typography variant="subtitle2" className="text-black-600">
                    Pago Piloto Promedio
                  </Typography>
                  <Typography variant="h5" className="font-bold text-black-700">
                    $
                    {parseFloat(
                      calculosvaciocargado2.total.pagopilotopromedio
                    ).toFixed(2)}
                  </Typography>
                </div>

                <div className="p-4 rounded-lg">
                  <Typography variant="subtitle2" className="text-black-600">
                    Gastos de Viáticos Promedio
                  </Typography>
                  <Typography variant="h5" className="font-bold text-black-700">
                    $
                    {parseFloat(
                      calculosvaciocargado2.total.pagoviaticospromedio
                    ).toFixed(2)}
                  </Typography>
                </div>

                <div className="p-4 rounded-lg">
                  <Typography variant="subtitle2" className="text-black-600">
                    Fondo de Ahorro del Flete (provisión mtto)
                  </Typography>
                  <Typography variant="h5" className="font-bold text-black-700">
                    $
                    {parseFloat(
                      calculosvaciocargado2.total.pagomantenimientopromedio
                    ).toFixed(2)}
                  </Typography>
                </div>

                <div className="p-4 rounded-lg">
                  <Typography variant="subtitle2" className="text-black-600">
                    Aporte del Flete para Administración
                  </Typography>
                  <Typography variant="h5" className="font-bold text-black-700">
                    $
                    {parseFloat(
                      calculosvaciocargado2.total.pagoadministracionpromedio
                    ).toFixed(2)}
                  </Typography>
                </div>

                <div className="p-4 rounded-lg">
                  <Typography variant="subtitle2" className="text-black-600">
                    Utilidad Líquida
                  </Typography>
                  <Typography variant="h5" className="font-bold text-black-700">
                    $
                    {parseFloat(
                      calculosvaciocargado2.total.utilidadliquida
                    ).toFixed(2)}
                  </Typography>
                </div>

                <div className="p-4 rounded-lg">
                  <Typography variant="subtitle2" className="text-black-600">
                    Valor de Tarifa
                  </Typography>
                  <Typography variant="h5" className="font-bold text-black-700">
                    $
                    {parseFloat(
                      calculosvaciocargado2.total.valortarifa
                    ).toFixed(2)}
                  </Typography>
                </div>
              </div>
            </div>
          )}
          {!mostrarRuta && calculosvaciocargado2 && isMobileScreen && (
            <div
              className="p-4 "
              style={isMobileScreen ? { marginTop: "-40px" } : {}}
            >
              <Button
                variant="contained"
                fullWidth
                style={{
                  backgroundColor: "#0c6efe",
                  color: "#fff",
                }}
                onClick={() => {
                  setMostrarFlete(!mostrarFlete);
                }}
                className="w-full"
              >
                {!mostrarFlete ? "Obtener Información" : "Atras"}
              </Button>
            </div>
          )}
          {mostrarRuta && calculosvaciocargado2 && (
            <div>
              <Typography
                variant="subtitle1"
                className="font-semibold text-black mb-3 text-center"
                style={{
                  fontSize: isMobile ? "15.5px" : "19px",
                  whiteSpace: "nowrap",
                  marginTop: isMobile ? "-50px" : "30px",
                }}
              >
                Mejor Ruta a Seguir en ambos Sentidos
              </Typography>

              <Typography
                className="m-2 text-center"
                style={{
                  fontSize: "15.5px",

                  marginLeft: "10px",
                  marginBottom: "10px",
                }}
              >
                <strong>
                  DE {selectedOrigin} A {selectedDestination}
                </strong>
              </Typography>
              <div className="space-y-2 bg-white rounded-lg">
                {calculosvaciocargado2.total.rutaCompleta ? (
                  formatearRuta(
                    calculosvaciocargado2.total.rutaCompleta,
                    invert
                  ).map((paso, index) => (
                    <div key={index} className="flex items-start space-x-3 ">
                      <div className="min-w-[24px] h-6 bg-black-100 rounded-full flex items-center justify-center">
                        <Typography variant="body2" className="text-black-600 ">
                          -
                        </Typography>
                      </div>
                      <Typography variant="body2" className="text-black -600,">
                        {paso}
                      </Typography>
                    </div>
                  ))
                ) : (
                  <Typography variant="body2" className="text-black -500">
                    No hay instrucciones disponibles
                  </Typography>
                )}
              </div>
              <Typography
                className="text-center"
                style={{
                  fontSize: "15.5px",

                  marginLeft: "10px",
                }}
              >
                <strong>
                  DE {selectedDestination} A {selectedOrigin}
                </strong>
              </Typography>
              {/* {calculosTemporales && isMobileScreen && (
                <div className="p-4">
                  <Button
                    variant="contained"
                    style={{
                      backgroundColor: "#0c6efe",
                      color: "#fff",
                    }}
                    onClick={() => {
                      setMostrarRuta(!mostrarRuta);
                    }}
                    className="w-full"
                  >
                    {mostrarRuta ? "Atras2" : "Ver Ruta"}
                  </Button>
                </div>
              )} */}
            </div>
          )}

          {!mostrarFlete && calculosvaciocargado2 && isMobileScreen && (
            <div className="p-4 mb-15">
              <Button
                variant="contained"
                fullWidth
                style={{
                  backgroundColor: "#0c6efe",
                  color: "#fff",
                  marginTop: "-15px",
                }}
                onClick={() => {
                  setMostrarRuta(!mostrarRuta);
                }}
                className="w-full"
              >
                {!mostrarRuta ? "Ver Ruta" : "Atras"}
              </Button>
            </div>
          )}
          {(!calculosTemporales && !showResults) ||
            (!calculosTemporales2 && showResults) ? (
            !isMobileScreen && (
              <div>
                {!calculosvaciocargado1 && !calculosvaciocargado2 && (
                  <div className="flex flex-col items-center justify-start h-full p-12">
                    <img
                      src={miau}
                      alt="Miau"
                      style={{ height: "70px", width: "80px" }}
                    />
                    <Typography className="text-black -800 font-bold mb-4">
                      Los valores se generan en dolares, el peso en kilogramos y
                      el combustible en galónes
                    </Typography>
                  </div>
                )}
              </div>
            )
          ) : (
            <div>
              {(() => {
                const rutaActual = activeModalidad2
                  ? calculosTemporales2
                  : calculosTemporales;
                return (
                  <div>
                    {/* {mostrarFlete && !calculosTemporales2?.info?.totales && (
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-2 ">
                        <div className="bg-white p-4 rounded-lg">
                          <Typography
                            variant="subtitle2"
                            className="text-black -600"
                          >
                            Origen
                          </Typography>
                          <Typography
                            variant="h6"
                            className="font-bold text-black -800"
                          >
                            {rutaActual.origen}
                          </Typography>
                        </div>
                        <div className="bg-white p-4 rounded-lg">
                          <Typography
                            variant="subtitle2"
                            className="text-black -600"
                          >
                            Destino
                          </Typography>
                          <Typography
                            variant="h6"
                            className="font-bold text-black -800"
                          >
                            {rutaActual.destino}
                          </Typography>
                        </div>
                      </div>
                    )} */}
                    {mostrarFlete && !calculosTemporales2?.info?.totales && (
                      <div>
                        <div style={{ marginTop: "-50px" }}>
                          <Typography
                            variant={isLargeScreen ? "h5" : "h6"}
                            className="text-center text-black -800 font-bold"
                          >
                            Información de Tarifa y Flete
                          </Typography>
                        </div>
                        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 gap-2 mb-2">
                          <div className="p-4 rounded-lg">
                            <Typography
                              variant="subtitle2"
                              className="text-black-600 font-medium"
                            >
                              Distancia en Kilometros
                            </Typography>
                            <Typography
                              variant="h5"
                              className="text-black-700 font-bold"
                            >
                              {rutaActual.info.kilometraje} km
                            </Typography>
                          </div>
                          <div className="p-4 rounded-lg">
                            <Typography
                              variant="subtitle2"
                              className="text-black-600"
                            >
                              Consumo de Diesel
                            </Typography>
                            <Typography
                              variant="h5"
                              className="font-bold text-black-700"
                            >
                              {rutaActual.info.consumoCombustible} galones
                            </Typography>
                          </div>
                          <div className="p-4 rounded-lg">
                            <Typography
                              variant="subtitle2"
                              className="text-black-600"
                            >
                              Gasto de Combustible
                            </Typography>
                            <Typography
                              variant="h5"
                              className="font-bold text-black-700"
                            >
                              ${rutaActual.info.costoCombustible}
                            </Typography>
                          </div>
                          <div className="bg-black-50 p-4 rounded-lg">
                            <Typography
                              variant="subtitle2"
                              className="text-black-600 font-medium"
                            >
                              Pago Piloto Promedio
                            </Typography>
                            <Typography
                              variant="h5"
                              className="font-bold text-black-700"
                            >
                              $
                              {rutaActual.info.calculos.factorPiloto.toFixed(2)}
                            </Typography>
                          </div>
                          <div className="bg-black-50 p-4 rounded-lg">
                            <Typography
                              variant="subtitle2"
                              className="text-black-600 font-medium"
                            >
                              Gasto de Viaticos Promedio
                            </Typography>
                            <Typography
                              variant="h5"
                              className="font-bold text-black-700"
                            >
                              $
                              {rutaActual.info.calculos.factorViaticos.toFixed(
                                2
                              )}
                            </Typography>
                          </div>
                          <div className="bg-black-50 p-4 rounded-lg">
                            <Typography
                              variant="subtitle2"
                              className="text-black-600 font-medium"
                            >
                              Fondo de Ahorro del Flete para Provision Mtto
                            </Typography>
                            <Typography
                              variant="h5"
                              className="font-bold text-black-700"
                            >
                              $
                              {rutaActual.info.calculos.factorMantenimiento.toFixed(
                                2
                              )}
                            </Typography>
                          </div>
                          <div className="bg-black-50 p-4 rounded-lg">
                            <Typography
                              variant="subtitle2"
                              className="text-black-600 font-medium"
                            >
                              Aporte del Flete para Administracion:
                            </Typography>
                            <Typography
                              variant="h5"
                              className="font-bold text-black-700"
                            >
                              $
                              {rutaActual.info.calculos.factorAdministracion.toFixed(
                                2
                              )}
                            </Typography>
                          </div>
                          <div className="bg-black-50 p-4 rounded-lg">
                            <Typography
                              variant="subtitle2"
                              className="text-black-600 font-medium"
                            >
                              Utilidad Liquida
                            </Typography>
                            <Typography
                              variant="h5"
                              className="font-bold text-black-700"
                            >
                              ${rutaActual.info.calculos.total15}
                            </Typography>
                          </div>
                          <div className="bg-black-50 p-4 rounded-lg">
                            <Typography
                              variant="subtitle2"
                              className="text-black-600 font-medium"
                            >
                              Valor de Tarifa
                            </Typography>
                            <Typography
                              variant="h5"
                              className="font-bold text-black-700"
                            >
                              ${rutaActual.info.calculos.sumatotal}
                            </Typography>
                          </div>
                        </div>

                        {calculosTemporales && isMobileScreen && (
                          <div className="p-4">
                            <Button
                              variant="contained"
                              fullWidth
                              style={{
                                backgroundColor: "#0c6efe",
                                color: "#fff",
                              }}
                              onClick={() => {
                                setMostrarFlete(!mostrarFlete);
                              }}
                              className="w-full"
                            >
                              {mostrarRuta ? "Atras" : "Atras"}
                            </Button>
                          </div>
                        )}
                      </div>
                    )}
                    <div
                      className="space-y-4 text-left"
                      style={{ marginTop: "-50px" }}
                    >
                      {calculosTemporales2?.info?.totales && mostrarFlete && (
                        <div className="space-y-4 text-left">
                          <Typography
                            variant={isLargeScreen ? "h5" : "h6"}
                            className="text-center text-black -800 font-bold"
                          >
                            Información de Tarifa y Flete
                          </Typography>
                          <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 gap-2 mb-2">
                            {/* Distancia en Kilometros */}
                            <div className="p-4 rounded-lg">
                              <Typography
                                variant="subtitle2"
                                className="text-black-600 font-medium"
                              >
                                Distancia en Kilometros:
                              </Typography>
                              <Typography
                                variant="h5"
                                className="font-bold text-black-700 font-bold"
                              >
                                {
                                  calculosTemporales2.info.totales
                                    .totalKilometraje
                                }{" "}
                                km
                              </Typography>
                            </div>

                            {/* Consumo Diesel */}
                            <div className="p-4 rounded-lg">
                              <Typography
                                variant="subtitle2"
                                className="text-black-600"
                              >
                                Consumo Diesel:
                              </Typography>
                              <Typography
                                variant="h5"
                                className="font-bold text-black-700"
                              >
                                {
                                  calculosTemporales2.info.totales
                                    .totalCombustible
                                }{" "}
                                galones
                              </Typography>
                            </div>

                            {/* Gasto de Combustible */}
                            <div className="p-4 rounded-lg">
                              <Typography
                                variant="subtitle2"
                                className="text-black-600"
                              >
                                Gasto de Combustible:
                              </Typography>
                              <Typography
                                variant="h5"
                                className="font-bold text-black-700"
                              >
                                $
                                {
                                  calculosTemporales2.info.totales
                                    .totalCostoCombustible
                                }
                              </Typography>
                            </div>

                            {/* Pago Piloto Promedio */}
                            <div className="p-4 rounded-lg">
                              <Typography
                                variant="subtitle2"
                                className="text-black-600"
                              >
                                Pago Piloto Promedio:
                              </Typography>
                              <Typography
                                variant="h5"
                                className="font-bold text-black-700"
                              >
                                ${calculosTemporales2.info.totales.totalPiloto}
                              </Typography>
                            </div>

                            {/* Gasto de Viaticos Promedio */}
                            <div className="p-4 rounded-lg">
                              <Typography
                                variant="subtitle2"
                                className="text-black-600"
                              >
                                Gasto de Viaticos Promedio:
                              </Typography>
                              <Typography
                                variant="h5"
                                className="font-bold text-black-700"
                              >
                                $
                                {calculosTemporales2.info.totales.totalViaticos}
                              </Typography>
                            </div>

                            {/* Fondo de Ahorro del flete Provision Mtto */}
                            <div className="p-4 rounded-lg">
                              <Typography
                                variant="subtitle2"
                                className="text-black-600"
                              >
                                Fondo de Ahorro del Flete Provision Mtto:
                              </Typography>
                              <Typography
                                variant="h5"
                                className="font-bold text-black-700"
                              >
                                $
                                {
                                  calculosTemporales2.info.totales
                                    .totalMantenimiento
                                }
                              </Typography>
                            </div>

                            {/* Aporte del Flete para Administracion */}
                            <div className="p-4 rounded-lg">
                              <Typography
                                variant="subtitle2"
                                className="text-black-600"
                              >
                                Aporte del Flete para Administración:
                              </Typography>
                              <Typography
                                variant="h5"
                                className="font-bold text-black-700"
                              >
                                $
                                {
                                  calculosTemporales2.info.totales
                                    .totalAdministracion
                                }
                              </Typography>
                            </div>

                            {/* Utilidad Liquida */}
                            <div className="p-4 rounded-lg">
                              <Typography
                                variant="subtitle2"
                                className="text-black-600"
                              >
                                Utilidad Liquida:
                              </Typography>
                              <Typography
                                variant="h5"
                                className="font-bold text-black-700"
                              >
                                ${calculosTemporales2.info.totales.sumatotal}
                              </Typography>
                            </div>

                            {/* Valor Tarifa */}
                            <div className="p-4 rounded-lg">
                              <Typography
                                variant="subtitle2"
                                className="text-black-600"
                              >
                                Valor Tarifa:
                              </Typography>
                              <Typography
                                variant="h5"
                                className="font-bold text-black-700"
                              >
                                ${calculosTemporales2.info.totales.totalsuma}
                              </Typography>
                            </div>

                            {/* Botón Condicional en móvil */}
                            {calculosTemporales && isMobileScreen && (
                              <div className="col-span-2 p-4 md:col-span-3">
                                <Button
                                  variant="contained"
                                  style={{
                                    backgroundColor: "#0c6efe",
                                    color: "#fff",
                                  }}
                                  onClick={() => setMostrarFlete(!mostrarFlete)}
                                  className="w-full"
                                >
                                  {showResults
                                    ? "Atras"
                                    : "Obtener Información"}
                                </Button>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                    {mostrarRuta && (
                      <div>
                        <Typography
                          variant="subtitle1"
                          className="font-semibold text-black mb-3 text-center"
                          style={{
                            fontSize: isMobile ? "15.5px" : "19px",
                            whiteSpace: "nowrap",
                            marginTop: isMobile ? "-50px" : "30px",
                          }}
                        >
                          Mejor Ruta a Seguir en ambos Sentidos
                        </Typography>

                        <Typography
                          className="m-2 text-center"
                          style={{
                            fontSize: "15.5px",

                            marginLeft: "10px",
                            marginBottom: "10px",
                          }}
                        >
                          <strong>
                            DE {selectedOrigin} A {selectedDestination}
                          </strong>
                        </Typography>
                        <div className="space-y-2 bg-white rounded-lg">
                          {rutaActual.info.rutaCompleta ? (
                            formatearRuta(
                              rutaActual.info.rutaCompleta,
                              invert
                            ).map((paso, index) => (
                              <div
                                key={index}
                                className="flex items-start space-x-3 "
                              >
                                <div className="min-w-[24px] h-6 bg-black-100 rounded-full flex items-center justify-center">
                                  <Typography
                                    variant="body2"
                                    className="text-black-600 "
                                  >
                                    -
                                  </Typography>
                                </div>
                                <Typography
                                  variant="body2"
                                  className="text-black -600,"
                                >
                                  {paso}
                                </Typography>
                              </div>
                            ))
                          ) : (
                            <Typography
                              variant="body2"
                              className="text-black -500"
                            >
                              No hay instrucciones disponibles
                            </Typography>
                          )}
                        </div>
                        <Typography
                          className="text-center"
                          style={{
                            fontSize: "15.5px",

                            marginLeft: "10px",
                          }}
                        >
                          <strong>
                            DE {selectedDestination} A {selectedOrigin}
                          </strong>
                        </Typography>
                        {calculosTemporales && isMobileScreen && (
                          <div className="p-4">
                            <Button
                              variant="contained"
                              style={{
                                backgroundColor: "#0c6efe",
                                color: "#fff",
                              }}
                              onClick={() => {
                                setMostrarRuta(!mostrarRuta);
                              }}
                              className="w-full"
                            >
                              {mostrarRuta ? "Atras" : "Ver Ruta"}
                            </Button>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                );
              })()}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}